if (!customElements.get('ceylera-collection-hub')) {
  customElements.define('ceylera-collection-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const input = this.querySelector('[data-hub-filter]');
      if (!input) return;
      const cards = [...this.querySelectorAll('[data-hub-card]')];
      const groups = [...this.querySelectorAll('[data-hub-group]')];
      const empty = this.querySelector('[data-hub-empty]');
      const status = this.querySelector('[data-hub-status]');
      const hint = this.querySelector('.chub__hint');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const filter = () => {
        const term = normalize(input.value);
        let count = 0;
        cards.forEach(card => {
          card.hidden = term !== '' && !normalize(card.dataset.hubText).includes(term);
          if (!card.hidden) count++;
        });
        groups.forEach(group => {
          group.hidden = ![...group.querySelectorAll('[data-hub-card]')].some(card => !card.hidden);
        });
        if (empty) empty.hidden = count !== 0;
        if (status) status.textContent = term ? status.dataset.pattern.replace('[count]', String(count)) : '';
        if (hint) hint.hidden = term !== '';
      };
      input.addEventListener('input', filter);
      this.querySelector('[data-hub-reset]')?.addEventListener('click', () => {
        input.value = '';
        filter();
        input.focus();
      });
    }
  });
}
